import './App.css';
import React from 'react';
import MainView from "./views/MainView";
import Box from "@mui/material/Box";
import SingleView from "./views/SingleView";

const MAPBOX_TOKEN = ''; // Set your mapbox token here
function App() {
    const [view, setView] = React.useState(null);

    if (view === null) {
        return (<MainView setView={setView}/>)
    } else {
        if (view) {
            return (<SingleView setView={setView} path={view}/>)
        }
    }

}

export default App;
